import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { profileQuestion, profileAnswer, getPlayerToken } from "../lib/api";

/**
 * Collecte progressive du profil (façon CRM fidélité) : à chaque nouvelle partie,
 * UNE petite question (âge puis e-mail) — RÉSERVÉ aux utilisateurs à compte (connectés),
 * réponse facultative (« Passer »).
 */
export default function ProfileNudge() {
  const [q, setQ] = useState(null); // { field, question, first_name }
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!getPlayerToken()) return; // seulement les joueurs connectés
    profileQuestion()
      .then((d) => { if (d?.field) setQ(d); })
      .catch(() => {});
  }, []);

  if (!q) return null;

  const submit = async () => {
    if (!val.trim() || busy) return;
    setBusy(true);
    try {
      await profileAnswer({ field: q.field, value: val.trim() });
      toast.success("Merci ! 🎁");
      setQ(null);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Réponse invalide");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed bottom-3 inset-x-3 z-40 flex justify-center pointer-events-none">
      <div className="pointer-events-auto w-full max-w-sm bg-white text-ink rounded-3xl p-4" style={{ boxShadow: "0 8px 0 #a81a0c" }}>
        <p className="font-display font-bold text-sm mb-0.5">
          {q.first_name ? `${q.first_name}, une` : "Une"} petite question pour mieux te gâter 🎁
        </p>
        <p className="text-xs text-gray-500 mb-2">{q.question}</p>
        <div className="flex gap-2 items-center">
          <input
            type={q.field === "email" ? "email" : "number"}
            inputMode={q.field === "email" ? "email" : "numeric"}
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder={q.field === "email" ? "ton@email.com" : "ex. 27"}
            data-testid="profile-nudge-input"
            className="flex-1 min-w-0 border-2 border-gray-200 rounded-xl px-3 py-2 text-sm outline-none focus:border-[#F9B81E]"
          />
          <button onClick={submit} disabled={busy} data-testid="profile-nudge-ok"
            className="bg-[#E20613] text-white font-black px-4 py-2 rounded-xl text-sm disabled:opacity-50">
            OK
          </button>
          <button onClick={() => setQ(null)} className="text-gray-400 text-xs px-1">Passer</button>
        </div>
      </div>
    </div>
  );
}
